import { useRef, useEffect } from 'react';

var useUpdateEffect = function useUpdateEffect(effect, deps) {
  var mounted = useRef(false);
  useEffect(function () {
    if (mounted.current) {
      effect();
    } else {
      mounted.current = true;
    }
  }, deps);
};

export { useUpdateEffect };